import React from 'react';
import TruncatedText from '../../utils/TruncatedText';

export const NameBodyTemplate = (rowData: any, fieldPrefix: 'agent' | 'supervisor' | 'manager') => {
    return (
        <span className="image-text">
            {rowData[`${fieldPrefix}_name`]} ({rowData[`${fieldPrefix}_number`]})
        </span>
    );
};
export const TruncatedTextTemplate = (rowData: any) => {
    return (
        <TruncatedText
                            text={rowData.employee_name}
                            maxLength={35}
                        />
    );
};

